import Icon from "./IconBase.js";
const UnmarkedLectureIcon = (props) => {
  return (
    <Icon width="36" height="36" viewBox="0 0 36 36" {...props}>
      <svg
        width="36"
        height="36"
        viewBox="0 0 36 36"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M18 0C15.6362 0 13.2956 0.465584 11.1117 1.37017C8.92784 2.27475 6.94353 3.60062 5.27208 5.27208C1.89642 8.64773 0 13.2261 0 18C0 22.7739 1.89642 27.3523 5.27208 30.7279C6.94353 32.3994 8.92784 33.7252 11.1117 34.6298C13.2956 35.5344 15.6362 36 18 36C22.7739 36 27.3523 34.1036 30.7279 30.7279C34.1036 27.3523 36 22.7739 36 18C36 15.6362 35.5344 13.2956 34.6298 11.1117C33.7252 8.92784 32.3994 6.94353 30.7279 5.27208C29.0565 3.60062 27.0722 2.27475 24.8883 1.37017C22.7044 0.465584 20.3638 0 18 0Z"
          fill="#FFF6E3"
        />
        <path
          d="M18 8C12.4772 8 8 12.4772 8 18C8 23.5228 12.4772 28 18 28C23.5228 28 28 23.5228 28 18C28 12.4772 23.5228 8 18 8Z"
          stroke="#D29822"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18 14L17.99 14"
          stroke="#D29822"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18 22L18 18"
          stroke="#D29822"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </Icon>
  );
};
export default UnmarkedLectureIcon;
